export const useIsProd = (): boolean => {
  return window.getEnv() === 'production';
};
